var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 593,
    viewBox: "0 0 637 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.94 459.738C117.643 444.061 171.092 405.713 205.084 354.188C215.55 338.318 224.42 320.564 225.153 301.56C225.886 282.555 216.759 262.2 199.438 254.35C179.765 245.426 154.695 256.035 144.143 274.879C133.591 293.722 136.197 318.093 147.196 336.679C158.196 355.266 176.472 368.621 196.075 377.694C253.301 404.202 321.663 396.605 379.683 371.865C437.704 347.124 487.487 306.846 536.449 267.082",
    stroke: "url(#paint0_linear_56_69)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.174 231.265C553.384 203.477 574.558 179.713 600.463 163.89C596.01 184.68 591.266 205.322 586.82 226.119C586.622 227.053 586.416 227.992 586.217 228.926L582.697 245.398C582.459 246.533 580.794 246.411 580.721 245.261L579.992 234.296C579.881 232.631 581.739 231.565 583.115 232.513L583.256 232.604C584.366 233.358 584.425 234.976 583.376 235.81C575.335 242.265 567.293 248.72 559.251 255.174L550.855 229.198C537.825 233.119 522.473 226.882 515.857 214.991L600.218 164.003C577.736 187.166 559.676 221.274 561.027 253.525",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_69",
    x1: 536,
    y1: 269.5,
    x2: 49,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 610.02,
    height: 262.27,
    fill: "white",
    transform: "translate(0 390.542) rotate(-39.8076)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.d5eb281d8ea57ed6a7a3ee2e6ed985c7.svg";
export { ForwardRef as ReactComponent };